import { render, staticRenderFns } from "./AppRodaSaude.vue?vue&type=template&id=7663cffc&"
import script from "./AppRodaSaude.vue?vue&type=script&lang=js&"
export * from "./AppRodaSaude.vue?vue&type=script&lang=js&"
import style0 from "./AppRodaSaude.vue?vue&type=style&index=0&id=7663cffc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports